import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function HireBand() {
  const { t } = useTranslation(['hire']);
  const github = profile.social.find((link) => link.id === 'github');
  const linkedin = profile.social.find((link) => link.id === 'linkedin');

  return (
    <section id="hire" className="hire">
      <div className="hire__text">
        <h2 className="hire__title">
          {t('hire:titleLine1')}
          <br />
          {t('hire:titleLine2')}
        </h2>
        <p className="hire__lede">{t('hire:lede')}</p>
      </div>

      <div className="hire__actions">
        <a className="hire__mail" href={`mailto:${profile.email}`} dir="ltr">
          {profile.email}
        </a>
        <div className="hire__links">
          {github && (
            <a href={github.href} rel="me noreferrer" target="_blank">
              {t('hire:github')}
            </a>
          )}
          {linkedin && (
            <a href={linkedin.href} rel="me noreferrer" target="_blank">
              {t('hire:linkedin')}
            </a>
          )}
          <a href={profile.cvPath} download>
            {t('hire:cv')}
          </a>
        </div>
      </div>
    </section>
  );
}
